import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "stopwatch",
  "use": "stopwatch-usage",
  "viewBox": "0 0 40 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 48\" id=\"stopwatch\"><path d=\"M20 10.5c9.941 0 18 8.059 18 18s-8.059 18-18 18-18-8.059-18-18 8.059-18 18-18zm0 0v-9M32 15l3.75-3.75M35 10.5l1.5 1.5m-12-10.5h-9M20 30l-7.5-8.302\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/stopwatch.svg
// module id = rGVb
// module chunks = 39 44